export class FormConfig {
    showRequiredAsterisk = true;
}
